<template lang="pug">
  header.header#header
    HeaderVideo
    .container
      HeaderTitle
      HeaderSocials
      HeaderCollection(v-if="showCollection")
      HeaderBanner(v-if="showBanner")
    HeaderToxis(v-if="showToxisBlock")
    HeaderKhabib(v-if="showKhabibBlock")
</template>

<script>
import Rellax from 'rellax'

import HeaderSocials from './HeaderSocials'
import HeaderTitle from './HeaderTitle'
import HeaderCollection from './HeaderCollection'
import HeaderVideo from './HeaderVideo'
import { mapState } from 'vuex'
import HeaderToxis from './HeaderToxis'
import HeaderKhabib from './HeaderKhabib'
import HeaderBanner from '@/components/header/HeaderBanner.vue'

export default {
  name: 'Header',
  components: {
    HeaderKhabib,
    HeaderToxis,
    HeaderVideo,
    HeaderCollection,
    HeaderBanner,
    HeaderTitle,
    HeaderSocials
  },
  mounted () {
    this.$nextTick(() => {
      new Rellax(this.$el, {
        speed: -5
      })
    })
  },
  computed: {
    ...mapState('siteVersions', {
      siteVersion: 'item'
    }),
    showCollection: vm => ['kz'].includes(vm.siteVersion.code),
    showBanner: vm => vm.siteVersion.code === 'ru',
    showToxisBlock: () => false,
    showKhabibBlock: () => false
  }
}
</script>
